import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { RootState } from './store';
import { setUserToken } from '../features/auth/authSlice';
import { fetchTokenWithRefreshToken as fetchHwbTokenWithRefreshToken } from '../features/auth/hwbAuth/hwbService';
import { fetchTokenWithRefreshToken as fetchBBTokenWithRefreshToken } from '../features/auth/bbOauth/bbOauthService';

const baseQuery = fetchBaseQuery({
  baseUrl:
    process.env.REACT_APP_RESOURCES_API_URL ??
    'https://36h5qfaq9c.execute-api.eu-west-2.amazonaws.com/dev/',
  prepareHeaders: (headers, { getState, extra, endpoint, type, forced }) => {
    const rootState = getState() as RootState;
    const token = rootState.auth?.userToken?.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
  }
});

/** Function to attempt baseQuery and will retry if token needs refresh */
const baseQueryWithReAuthentication: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  let response = await baseQuery(args, api, extraOptions)

  if (response.error) {
    const rootState = api.getState() as RootState;
    const userToken = rootState.auth?.userToken;

    // If user logged in
    if (userToken) {
      // Has expired token
      if (new Date(userToken.expires) < new Date()) {
        let getNewToken;
          
        // Generate new token using service first logged in with
        // Currently either `hwb` or `bitbucket`
        switch (userToken.service) {
          case "hwb":
            getNewToken = await fetchHwbTokenWithRefreshToken(userToken.refreshToken)
            break;
          case "bitbucket": 
            getNewToken = await fetchBBTokenWithRefreshToken(userToken.refreshToken);
            break;
        }

        if (getNewToken) {
          api.dispatch(setUserToken(getNewToken))

          response = await baseQuery(args, api, extraOptions);
        } else {
          // If token couldn't be refreshed then remove stale token
          api.dispatch(setUserToken(undefined));
          api.dispatch(apiSlice.util.invalidateTags(["User"]))
          localStorage.removeItem('BL_CMS_STATE');
        }
      }
    }
  }

  return response;
} 

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReAuthentication,
  tagTypes: ['Resources', 'ResourceRef','UserResourceRef', 'User', 'Logs'],
  endpoints: (builder) => ({})
});
